import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'msToSec',
    standalone: false
})
export class MsToSecPipe implements PipeTransform {

  transform(ms: number): any {
    const sec: number = ms / 1000
    return sec.toFixed(1)
  }

}
